let statusCity = {
    '广东':{
      seriesData:[
        { parentName:'广东',name: "黄埔海关",code:'52', value: [113.545611,23.383707]},
        { parentName:'广东',name: "江门海关",code:'68', value: [113.081415, 22.579089]},
        { parentName:'广东',name: "汕头海关",code:'60', value: [116.747794,23.383024]},
        { parentName:'广东',name: "湛江海关",code:'67', value: [110.357229,21.206645]},
        { parentName:'广东',name: "深圳海关",code:'53', value: [114.072841,22.546755]},
        { parentName:'广东',name: "拱北海关",code:'57', value: [113.563842,22.223781]},
        { parentName:'广东',name: "广州海关",code:'51', value: [113.326979,23.126103]},
      ],
      regions:[
        {name:'黄埔区',code:'52',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'增城区',code:'52',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'东莞市',code:'52',fontColor:'#000',BgColor:'#A2D6F5'},

        {name:'江门市',code:'68',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'阳江市',code:'68',fontColor:'#000',BgColor:'#63AEEB'},

        {name:'汕头市',code:'60',fontColor:'#000',BgColor:'#0074FF'},
        {name:'潮州市',code:'60',fontColor:'#000',BgColor:'#0074FF'},
        {name:'普宁市',code:'60',fontColor:'#000',BgColor:'#0074FF'},
        {name:'揭阳市',code:'60',fontColor:'#000',BgColor:'#0074FF'},
        {name:'汕尾市',code:'60',fontColor:'#000',BgColor:'#0074FF'},
        {name:'梅州市',code:'60',fontColor:'#000',BgColor:'#0074FF'},

        {name:'湛江市',code:'67',fontColor:'#000',BgColor:'#0290A9'},
        {name:'茂名市',code:'67',fontColor:'#000',BgColor:'#0290A9'},

        {name:'深圳市',code:'53',fontColor:'#000',BgColor:'#38B03F'},
        {name:'惠州市',code:'53',fontColor:'#000',BgColor:'#38B03F'},

        {name:'珠海市',code:'57',fontColor:'#000',BgColor:'#B4A2FF'},
        {name:'中山市',code:'57',fontColor:'#000',BgColor:'#B4A2FF'},

        {name:'佛山市',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'肇庆市',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'韶关市',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'河源市',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'清远市',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'云浮市',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'荔湾区',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'越秀区',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'海珠区',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'天河区',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'白云区',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'番禺区',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'花都区',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'南沙区',code:'51',fontColor:'#000',BgColor:'#FFD654'},
        {name:'从化区',code:'51',fontColor:'#000',BgColor:'#FFD654'}
      ],
    },
    '内蒙古':{
      seriesData:[
        { parentName:'内蒙古',code:'06',name: "满洲里海关", value: [117.508763,49.589511]},
        { parentName:'内蒙古',code:'07',name: "呼和浩特海关", value: [	111.779042,40.839318]},
      ],
      regions:[
        {name:'呼伦贝尔市',code:'06',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'赤峰市',code:'06',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'通辽市',code:'06',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'兴安盟',code:'06',fontColor:'#000',BgColor:'#63AEEB'},

        {name:'锡林郭勒盟',code:'07',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'呼和浩特市',code:'07',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'包头市',code:'07',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'鄂尔多斯市',code:'07',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'乌海市',code:'07',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'巴彦淖尔市',code:'07',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'乌兰察布市',code:'07',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'阿拉善盟',code:'07',fontColor:'#000',BgColor:'#A2D6F5'},
      ],
    },
    '辽宁':{
      seriesData:[
        { parentName:'辽宁',name: "大连海关",code:'09', value: [123.310344,39.868812]},
        { parentName:'辽宁',name: "沈阳海关",code:'08', value: [123.468733,41.751897]}
      ],
      regions:[
        {name:'大连市',code:'09',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'鞍山市',code:'09',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'本溪市',code:'09',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'丹东市',code:'09',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'营口市',code:'09',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'盘锦市',code:'09',fontColor:'#000',BgColor:'#63AEEB'},

        {name:'沈阳市',code:'08',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'抚顺市',code:'08',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'辽阳市',code:'08',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'锦州市',code:'08',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'阜新市',code:'08',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'葫芦岛市',code:'08',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'铁岭市',code:'08',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'朝阳市',code:'08',fontColor:'#000',BgColor:'#A2D6F5'},
      ],
    },
    '福建':{
      seriesData:[
        { parentName:'福建',name: "厦门海关",code:'37', value: [117.673854,25.263332]},
        { parentName:'福建',name: "福州海关",code:'35', value: [119.420199,26.021305]}
      ],
      regions:[
        {name:'厦门市',code:'37',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'泉州市',code:'37',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'漳州市',code:'37',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'龙岩市',code:'37',fontColor:'#000',BgColor:'#63AEEB'},

        {name:'福州市',code:'35',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'莆田市',code:'35',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'三明市',code:'35',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'南平市',code:'35',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'宁德市',code:'35',fontColor:'#000',BgColor:'#A2D6F5'},
      ],
    },
    '山东':{
      seriesData:[
        { parentName:'山东',name: "济南海关",code:'43', value: [116.966009,36.890723]},
        { parentName:'山东',name: "青岛海关",code:'42', value: [120.318301,36.063604]}
      ],
      regions:[
        {name:'济南市',code:'43',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'淄博市',code:'43',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'潍坊市',code:'43',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'泰安市',code:'43',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'东营市',code:'43',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'德州市',code:'43',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'滨州市',code:'43',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'聊城市',code:'43',fontColor:'#000',BgColor:'#63AEEB'},

        {name:'青岛市',code:'42',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'枣庄市',code:'42',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'烟台市',code:'42',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'济宁市',code:'42',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'威海市',code:'42',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'日照市',code:'42',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'临沂市',code:'42',fontColor:'#000',BgColor:'#A2D6F5'},
        {name:'菏泽市',code:'42',fontColor:'#000',BgColor:'#A2D6F5'},
      ],
    },
    '浙江':{
      seriesData:[
        { parentName:'浙江',name: "杭州海关",code:'29', value: [119.387844,28.360325]},
        { parentName:'浙江',name: "宁波海关",code:'31', value: [121.543503,29.877679]}
      ],
      regions:[
        {name:'杭州市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'温州市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'嘉兴市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'湖州市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'绍兴市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'金华市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'衢州市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'舟山市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'台州市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},
        {name:'丽水市',code:'29',fontColor:'#000',BgColor:'#63AEEB'},

        {name:'宁波市',code:'31',fontColor:'#000',BgColor:'#A2D6F5'}
      ],
    },
    '宁夏':{
      seriesData:[
        { parentName:'宁夏',name: "银川海关",code:'96', value: [106.254053,38.482608]},
      ],
      regions:[
        {name:'宁夏',code:'96',fontColor:'#000',BgColor:'#CDFFCB'},
        {name:'银川市',code:'96',fontColor:'#000',BgColor:'#CDFFCB'},
        {name:'石嘴山市',code:'96',fontColor:'#000',BgColor:'#CDFFCB'},
        {name:'吴忠市',code:'96',fontColor:'#000',BgColor:'#CDFFCB'},
        {name:'固原市',code:'96',fontColor:'#000',BgColor:'#CDFFCB'},
        {name:'中卫市',code:'96',fontColor:'#000',BgColor:'#CDFFCB'},
      ],
    },
    '新疆':{
      seriesData:[
        { parentName:'新疆',name: "乌鲁木齐海关",code:'94', value: [87.577930,43.852061]},
      ],
      regions:[
        {name:'新疆',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'乌鲁木齐市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'克拉玛依市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'吐鲁番市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'哈密市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'阿克苏地区',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'喀什地区',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'和田地区',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'塔城地区',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'阿勒泰地区',code:'94',fontColor:'#000',BgColor:'#4E8C40'},

        {name:'昌吉回族自治州',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'博尔塔拉蒙古自治州',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'巴音郭楞蒙古自治州',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'克孜勒苏柯尔克孜自治州',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'伊犁哈萨克自治州',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'阿拉尔市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'图木舒克市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'昆玉市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'铁门关市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'胡杨河市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'五家渠市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'双河市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
        {name:'北屯市',code:'94',fontColor:'#000',BgColor:'#4E8C40'},
      ],
    },
    '云南':{
      seriesData:[
        { parentName:'云南',name: "昆明海关",code:'86', value: [102.725543,25.051855]},
      ],
      regions:[
        {name:'云南',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'昆明市',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'曲靖市',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'玉溪市',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'保山市',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'昭通市',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'丽江市',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'普洱市',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'临沧市',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},

        {name:'楚雄彝族自治州',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'红河哈尼族彝族自治州',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'文山壮族苗族自治州',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'西双版纳傣族自治州',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'大理白族自治州',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'德宏傣族景颇族自治州',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'怒江傈僳族自治州',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
        {name:'迪庆藏族自治州',code:'86',fontColor:'#000',BgColor:'#CEEBFC'},
      ],
    },

    '黑龙江':{
      seriesData:[
        { parentName:'黑龙江',name: "哈尔滨海关",code:'19', value: [126.694905,45.760188]},
      ],
      regions:[
        {name:'黑龙江',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'哈尔滨市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'齐齐哈尔市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'鸡西市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'鹤岗市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'双鸭山市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'大庆市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'伊春市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'佳木斯市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'七台河市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'牡丹江市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'黑河市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'绥化市',code:'19',fontColor:'#000',BgColor:'#DDDDDD'},
        {name:'大兴安岭地区',code:'19',fontColor:'#000',BgColor:'#DDDDDD'}
      ],
    },

    '吉林':{
      seriesData:[
        { parentName:'吉林',name: "长春海关",code:'15', value: [125.370311,43.869837]},
      ],
      regions:[
        {name:'吉林',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
        {name:'长春市',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
        {name:'吉林市',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
        {name:'四平市',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
        {name:'辽源市',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
        {name:'通化市',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
        {name:'白山市',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
        {name:'松原市',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
        {name:'白城市',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
        {name:'延边朝鲜族自治州',code:'15',fontColor:'#000',BgColor:'#EBE8EA'},
      ],
    },

    '广西':{
      seriesData:[
        { parentName:'广西',name: "南宁海关",code:'72', value: [108.398801,22.813465]},
      ],

      regions:[
        {name:'广西',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'南宁市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'柳州市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'桂林市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'梧州市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},

        {name:'北海市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'防城港市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'钦州市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'贵港市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},

        {name:'玉林市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'百色市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'贺州市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'河池市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'来宾市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
        {name:'崇左市',code:'72',fontColor:'#000',BgColor:'#EAF9F4'},
      ],
    },

    '海南':{
      seriesData:[
        { parentName:'海南',name: "海口海关",code:'64', value: [110.326786,20.037975]},
      ],
      regions:[
        {name:'海南',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'海口市',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'三亚市',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'三沙市',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'儋州市',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},

        {name:'五指山市',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'文昌市',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'琼海市',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'万宁市',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'东方市',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'临高县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'澄迈县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'屯昌县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'琼中黎族苗族自治县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'白沙黎族自治县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'保亭黎族苗族自治县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'乐东黎族自治县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'定安县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'昌江黎族自治县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
        {name:'陵水黎族自治县',code:'64',fontColor:'#000',BgColor:'#FBE6EF'},
      ],
    },

    '河南':{
      seriesData:[
        { parentName:'河南',name: "郑州海关",code:'46', value: [113.704851,34.792610]},
      ],

      regions:[
        {name:'河南',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'郑州市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'开封市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'洛阳市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'平顶山市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'安阳市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'鹤壁市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'新乡市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'焦作市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'濮阳市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'许昌市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'漯河市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'三门峡市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'南阳市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},

        {name:'商丘市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'信阳市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'周口市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'驻马店市',code:'46',fontColor:'#000',BgColor:'#C7D98D'},
        {name:'济源市',code:'46',fontColor:'#000',BgColor:'#C7D98D'}
      ],
    },
    '河北':{
      seriesData:[
        { parentName:'河北',name: "石家庄海关",code:'04', value: [116.248301,37.937055]},
      ],

      regions:[
        {name:'河北',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'石家庄市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'唐山市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'秦皇岛市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'邯郸市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'邢台市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'保定市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'张家口市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'承德市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'沧州市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'廊坊市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'},
        {name:'衡水市',code:'04',fontColor:'#000',BgColor:'#F2DE7B'}
      ],
    },

    '湖北':{
      seriesData:[
        { parentName:'湖北',name: "武汉海关",code:'47', value: [114.210869,30.643204]},
      ],

      regions:[
        {name:'湖北',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'武汉市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'黄石市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'十堰市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'宜昌市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'襄阳市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'鄂州市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'荆门市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'孝感市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'荆州市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'黄冈市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'咸宁市',code:'47',fontColor:'#000',BgColor:'#00E079'},

        {name:'随州市',code:'47',fontColor:'#000',BgColor:'#00E079'},
        {name:'恩施土家族苗族自治州',code:'47',fontColor:'#000',BgColor:'#00E079'},
      ],
    },

    '安徽':{
      seriesData:[
        { parentName:'安徽',name: "合肥海关",code:'33', value: [	117.216991,31.784674]},
      ],
      regions: [
         {name: '安徽', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '合肥市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '芜湖市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '蚌埠市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '淮南市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '马鞍山市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '淮北市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '铜陵市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '安庆市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '黄山市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '滁州市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '阜阳市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '宿州市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '六安市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '亳州市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '池州市', code: '33', fontColor: '#000', BgColor: '#2177C7'},
          {name: '宣城市', code: '33', fontColor: '#000', BgColor: '#2177C7'}
      ]
    },
    "江西": {
      "seriesData": [
        {
          "parentName": "江西",
          "name": "南昌海关",
          "code": "40",
          "value": [115.892155, 28.676493] // 请替换为南昌海关实际经纬度
        }
      ],
      "regions": [
        { "name": "江西", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "南昌市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" }, // 随机生成的橙黄色，将用于所有市
        { "name": "景德镇市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "萍乡市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "九江市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "新余市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "鹰潭市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "赣州市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "吉安市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "宜春市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "抚州市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" },
        { "name": "上饶市", "code": "40", "fontColor": "#000", "BgColor": "#FFA500" }
      ]
    },
    "山西": {
      "seriesData": [
        {
          "parentName": "山西",
          "name": "太原海关",
          "code": "05",
          "value": [112.549265, 37.857034] // 请替换为太原海关实际经纬度
        }
      ],
      "regions": [
        { "name": "山西", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "太原市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" }, // 随机生成的橙红色，将用于所有市
        { "name": "大同市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "阳泉市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "长治市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "晋城市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "朔州市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "晋中市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "运城市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "忻州市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "临汾市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" },
        { "name": "吕梁市", "code": "05", "fontColor": "#000", "BgColor": "#FF6347" }
      ]
    },
     "上海": {
       "seriesData": [
         {
           "parentName": "上海",
           "name": "上海海关",
           "code": "22",
           "value": [121.496574,31.242287]
         }
       ],
       "regions": [
         { "name": "上海", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "黄浦区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "徐汇区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "长宁区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "静安区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "普陀区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "虹口区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "杨浦区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "闵行区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "宝山区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "嘉定区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "浦东新区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "金山区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "松江区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "青浦区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "奉贤区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" },
         { "name": "崇明区", "code": "22", "fontColor": "#000", "BgColor": "#2CD81F" }
       ]
     },
     "青海": {
       "seriesData": [
         {
           "parentName": "青海",
           "name": "西宁海关",
           "code": "97",
           "value": [101.7835, 36.6201] // 请替换为西宁海关的实际经纬度
         }
       ],
       "regions": [
         {"name":"青海","code":"97","fontColor":"#000","BgColor":"#F48FB1"}, // 随机生成的颜色值
         {"name":"西宁市","code":"97","fontColor":"#000","BgColor":"#F48FB1"}, // 随机生成的颜色值
         {"name":"海东市","code":"97","fontColor":"#000","BgColor":"#F48FB1"}, // 使用与西宁市相同的随机颜色值
         {"name":"海北藏族自治州","code":"97","fontColor":"#000","BgColor":"#F48FB1"},
         {"name":"黄南藏族自治州","code":"97","fontColor":"#000","BgColor":"#F48FB1"},
         {"name":"海南藏族自治州","code":"97","fontColor":"#000","BgColor":"#F48FB1"},
         {"name":"果洛藏族自治州","code":"97","fontColor":"#000","BgColor":"#F48FB1"},
         {"name":"玉树藏族自治州","code":"97","fontColor":"#000","BgColor":"#F48FB1"},
         {"name":"海西蒙古族藏族自治州","code":"97","fontColor":"#000","BgColor":"#F48FB1"}
       ]
     },
     "陕西": {
       "seriesData": [
         {
           "parentName": "陕西",
           "name": "西安海关",
           "code": "90",
           "value": [108.948667, 34.263161] // 请替换为西安海关的实际经纬度
         }
       ],
       "regions": [
         {"name":"陕西","code":"90","fontColor":"#000","BgColor":"#A5D6A7"}, // 随机生成的颜色值
         {"name":"西安市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"}, // 随机生成的颜色值
         {"name":"铜川市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"}, // 使用与西安市相同的随机颜色值
         {"name":"宝鸡市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"咸阳市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"渭南市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"延安市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"汉中市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"榆林市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"安康市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"商洛市","code":"90","fontColor":"#000","BgColor":"#A5D6A7"}
       ],
     },

     "贵州":{
       "seriesData":[
         {
           "parentName":"贵州",
           "name":"贵阳海关",
           "code":"83",
           "value":[106.713477,26.578344]
         }
       ],
       "regions":[
         {"name":"贵州","code":"83","fontColor":"#000","BgColor":"#67B26F"},
         {"name":"贵阳市","code":"83","fontColor":"#000","BgColor":"#67B26F"},
         {"name":"六盘水市","code":"83","fontColor":"#000","BgColor":"#67B26F"},
         {"name":"遵义市","code":"83","fontColor":"#000","BgColor":"#67B26F"},
         {"name":"安顺市","code":"83","fontColor":"#000","BgColor":"#67B26F"},
         {"name":"毕节市","code":"83","fontColor":"#000","BgColor":"#67B26F"},
         {"name":"铜仁市","code":"83","fontColor":"#000","BgColor":"#67B26F"},
         {"name":"黔西南布依族苗族自治州","code":"83","fontColor":"#000","BgColor":"#67B26F"},
         {"name":"黔东南苗族侗族自治州","code":"83","fontColor":"#000","BgColor":"#67B26F"},
         {"name":"黔南布依族苗族自治州","code":"83","fontColor":"#000","BgColor":"#67B26F"},
       ]
     },
     "江苏":{
       "seriesData":[
         {
           "parentName":"江苏",
           "name":"南京海关",
           "code":"23",
           "value":[118.634559,33.299678] // 假设这是南京海关的经纬度，请替换为实际值
         }
       ],
       "regions":[
         {"name":"江苏","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"南京市","code":"23","fontColor":"#000","BgColor":"#A52A2A"}, // 随机颜色示例
         {"name":"无锡市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"徐州市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"常州市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"苏州市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"南通市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"连云港市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"淮安市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"盐城市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"扬州市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"镇江市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"泰州市","code":"23","fontColor":"#000","BgColor":"#A52A2A"},
         {"name":"宿迁市","code":"23","fontColor":"#000","BgColor":"#A52A2A"}
         // 如果还有其他市级单位，请继续添加...
       ]
     },
     "四川":{
       "seriesData":[
         {
           "parentName":"四川",
           "name":"成都海关",
           "code":"79",
           "value":[104.065766,30.651653] // 假设这是成都海关的经纬度，请替换为实际值
         }
       ],
       "regions":[
          {"name":"四川","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"成都","code":"79","fontColor":"#000","BgColor":"#ED1C24"}, // 随机颜色示例
          {"name":"自贡","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"攀枝花","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"泸州","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"德阳","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"绵阳","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"广元","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"遂宁","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"内江","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"乐山","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"南充","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"眉山","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"宜宾","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"广安","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"达州","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"雅安","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"巴中","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"资阳","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"阿坝","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"甘孜","code":"79","fontColor":"#000","BgColor":"#ED1C24"},
          {"name":"凉山","code":"79","fontColor":"#000","BgColor":"#ED1C24"}
       ]
     },

     "湖南":{
       "seriesData":[
         {
           "parentName":"湖南",
           "name":"长沙海关",
           "code":"49",
           "value":[112.982273,28.194098] // 假设这是长沙海关的经纬度，请替换为实际值
         }
       ],
       "regions":[
         {"name":"湖南","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"长沙市","code":"49","fontColor":"#000","BgColor":"#F26C4F"}, // 随机颜色示例
         {"name":"株洲市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"湘潭市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"衡阳市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"邵阳市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"岳阳市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"常德市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"张家界市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"益阳市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"郴州市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"永州市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"怀化市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"娄底市","code":"49","fontColor":"#000","BgColor":"#F26C4F"},
         {"name":"湘西土家族苗族自治州","code":"49","fontColor":"#000","BgColor":"#F26C4F"}
         // 如果还有其他市级单位，请继续添加...
       ]
     },
     "甘肃":{
       "seriesData":[
         {
           "parentName":"甘肃",
           "name":"兰州海关",
           "code":"95",
           "value":[103.834158,36.057031] // 假设这是兰州海关的经纬度，请替换为实际值
         }
       ],
       "regions":[
         {"name":"甘肃","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"兰州市","code":"95","fontColor":"#000","BgColor":"#56A0D3"}, // 随机颜色示例
         {"name":"嘉峪关市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"金昌市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"白银市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"天水市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"武威市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"张掖市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"平凉市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"酒泉市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"庆阳市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"定西市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"陇南市","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"临夏回族自治州","code":"95","fontColor":"#000","BgColor":"#56A0D3"},
         {"name":"甘南藏族自治州","code":"95","fontColor":"#000","BgColor":"#56A0D3"}
         // 如果还有其他市级单位，请继续添加...
       ]
     },
     "西藏":{
       "seriesData":[
         {
           "parentName":"西藏",
           "name":"拉萨海关",
           "code":"88",
           "value":[91.132211,29.646631] // 假设这是拉萨海关的经纬度，请替换为实际值
         }
       ],
       "regions":[
         {"name":"西藏","code":"88","fontColor":"#000","BgColor":"#E16E64"},
         {"name":"拉萨市","code":"88","fontColor":"#000","BgColor":"#E16E64"}, // 随机颜色示例
         {"name":"日喀则市","code":"88","fontColor":"#000","BgColor":"#E16E64"},
         {"name":"昌都市","code":"88","fontColor":"#000","BgColor":"#E16E64"},
         {"name":"林芝市","code":"88","fontColor":"#000","BgColor":"#E16E64"},
         {"name":"山南市","code":"88","fontColor":"#000","BgColor":"#E16E64"},
         {"name":"那曲市","code":"88","fontColor":"#000","BgColor":"#E16E64"},
         {"name":"阿里地区","code":"88","fontColor":"#000","BgColor":"#E16E64"}
         // 如果还有其他市级单位，请继续添加...
       ]
     },

     "重庆":{
       "seriesData":[
         {
           "parentName":"重庆",
           "name":"重庆海关",
           "code":"80",
           "value":[106.551555,29.563014] // 假设这是重庆海关的经纬度，请替换为实际值
         }
       ],
       "regions":[
         {"name":"重庆","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"万州区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"}, // 随机颜色示例
         {"name":"涪陵区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"渝中区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"大渡口区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"江北区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"沙坪坝区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"九龙坡区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"南岸区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"北碚区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"万盛区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"双桥区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"渝北区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"巴南区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"黔江区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"长寿区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"綦江区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"潼南区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"铜梁区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"大足区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"荣昌区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"璧山区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"梁平区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"城口县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"丰都县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"垫江县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"武隆区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
         {"name":"忠县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"开州区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"云阳县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"奉节县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"巫山县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"巫溪县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"石柱土家族自治县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"秀山土家族苗族自治县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"酉阳土家族苗族自治县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"彭水苗族土家族自治县","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},

          {"name":"南川区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"江津区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"永川区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"江津区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},
          {"name":"合川区","code":"80","fontColor":"#000","BgColor":"#A5D6A7"},

          // 如果还有其他区级单位，请继续添加...
          ]
      },

      "北京":{
        "seriesData":[
          {
            "parentName":"北京",
            "name":"北京海关",
            "code":"01",
            "value":[116.407394,39.904211] // 假设这是北京海关的经纬度，请替换为实际值
          }
        ],
        "regions":[
          {"name":"北京","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"东城区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"}, // 随机颜色示例
          {"name":"西城区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"朝阳区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"丰台区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"石景山区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"海淀区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"顺义区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"通州区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"大兴区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"房山区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"门头沟区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"昌平区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"平谷区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"密云区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"怀柔区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"},
          {"name":"延庆区","code":"01","fontColor":"#000","BgColor":"#C4CCD3"}
          // 如果还有其他区级单位，请继续添加...
        ]
      },
      "天津":{
        "seriesData":[
          {
            "parentName":"天津",
            "name":"天津海关",
            "code":"02",
            "value":[117.219016,39.134757]
          }
        ],
        "regions":[
          {"name":"天津","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          {"name":"和平区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"河东区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"河西区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"南开区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"河北区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"红桥区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"东丽区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"西青区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"津南区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"北辰区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"武清区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"宝坻区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"滨海新区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"宁河区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"静海区","code":"02","fontColor":"#000","BgColor":"#F08A95"},
          		{"name":"蓟州区","code":"02","fontColor":"#000","BgColor":"#F08A95"}
          // 如果还有其他区级单位，请继续添加...
        ]
      }

  }

export default {
  statusCity: statusCity
};



// WEBPACK FOOTER //
// ./src/components/annotatedCity.js